import { endOfMonth, format, startOfMonth, subDays, subMonths } from 'date-fns'
import { DateRange } from '../partials/export-form'

const formattedDate = (date: Date) => format(date, 'MMM dd, yyyy')

export const renderFormattedRange = (item: DateRange) => {
  switch (item) {
    case DateRange.Today: {
      return formattedDate(new Date())
    }
    case DateRange.CurrentMonth: {
      return `${formattedDate(startOfMonth(new Date()))} - ${formattedDate(endOfMonth(new Date()))}`
    }
    case DateRange.Last7Days: {
      return `${formattedDate(subDays(new Date(), 7))} - ${formattedDate(new Date())}`
    }
    case DateRange.LastMonth: {
      return `${formattedDate(startOfMonth(subMonths(new Date(), 1)))} - ${formattedDate(endOfMonth(subMonths(new Date(), 1)))}`
    }
    default: {
      return ''
    }
  }
}
